// extracted by mini-css-extract-plugin
module.exports = {"Column":"Scnd_Column__3nbfc","img":"Scnd_img__3zxSx","heading":"Scnd_heading__E_CMR","para":"Scnd_para__1H7DV","container":"Scnd_container__3Ruyh"};